import React from 'react';
import {
  Button,
  DatePicker,
  FormRadioList,
  SearchField,
} from '@ihsm/ui-shared';
import { CollapsiblePanel } from 'shared/components/CollapsiblePanel';
import { JOB_REPORT_TYPES, JOB_STATUS } from '../../constants';
import { useJobsPage } from '../../hooks';
import './JobsSearch.scss';

export const JobsSearch: React.FC = () => {
  const {
    selectedType,
    onReportTypeChange,
    selectedStatus,
    onChangeStatus,
    selectedStarted,
    onChangeSelectedStarted,
    onApplyFilters,
    onReset,
    datePickerValue,
  } = useJobsPage();

  return (
    <CollapsiblePanel className="jobs-search">
      <div className="jobs-search__top-controls">
        <div className="jobs-search__search-field">
          <SearchField />
        </div>

        <div className="jobs-search__radio-area">
          <FormRadioList
            title="Report Type"
            options={JOB_REPORT_TYPES}
            radioName="jobs-report-radio"
            value={selectedType}
            onChange={(e) => onReportTypeChange(e.target.value)}
          />
        </div>

        <div className="jobs-search__radio-area">
          <FormRadioList
            title="Status"
            options={JOB_STATUS}
            radioName="jobs-status-radio"
            value={selectedStatus}
            onChange={(e) => onChangeStatus(e.target.value)}
          />
        </div>

        <div className="jobs-search__started-section">
          <div className="jobs-search__started-title">Started</div>
          <div className="jobs-search__selected-started-box">
            <div className="jobs-search__selected-started-date">
              {selectedStarted}
            </div>
            <DatePicker
              alignByRightCorner
              className="jobs-search__date-picker"
              value={datePickerValue}
              onChange={onChangeSelectedStarted}
            />
          </div>
        </div>
      </div>

      <div className="jobs-search__bottom-controls">
        <Button
          text="Reset All"
          onClick={onReset}
          className="jobs-search__bottom-button"
          theme="transparent"
        />

        <Button
          text="Apply Filters"
          className="jobs-search__bottom-button"
          onClick={onApplyFilters}
          customClass="apply-filters"
        />
      </div>
    </CollapsiblePanel>
  );
};
